<template>
  <v-app class="bg-login" id="auth">
    <v-main>
      <v-container class="fill-height">
        <v-row class="fill-height">
          <v-col cols="12" lg="5" class="hidden-md-and-down">
            <v-card flat height="100%" rounded="xl">
              <v-img src="../../assets/login_background.webp" height="100%">
                <div class="left__text white--text text-h5">
                  <p class="text-uppercase mb-0">Portal</p>
                  <p class="text-uppercase">Administrativo</p>
                </div>
              </v-img>
            </v-card>
          </v-col>
          <v-col cols="12" lg="7" class="d-flex align-center">
            <v-row>
              <v-col cols="8" offset="2">
                <div
                  class="logo-container d-flex flex-column justify-center align-center"
                >
                  <router-link :to="{ name: 'Login' }">
                    <img
                      src="../../assets/logo_av_securities.png"
                      alt="Logo Av"
                      class="logo"
                    />
                  </router-link>
                  <p class="logo-container__text silver--text mt-5">
                    ¡Bienvenido de nuevo! Por favor, ingrese a su cuenta.
                  </p>
                </div>
              </v-col>
              <v-col cols="10" offset="1">
                <v-card rounded elevation="0" v-if="this.correoSend === false">
                  <v-card-text>
                    <ValidationObserver ref="observer" v-slot="{ invalid }">
                      <form @submit.prevent="handleSubmit">
                        <v-row class="px-md-5">
                          <v-col cols="12">
                            <!-- EMAIL FIELD -->
                            <ValidationProvider
                              name="Correo electrónico"
                              rules="required|email"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                label="Correo electrónico"
                                v-model="user.email"
                                hint="Introduzca su correo"
                                autofocus
                                :disabled="disabled == 1"
                                :error-messages="errors[0]"
                              />
                            </ValidationProvider>
                          </v-col>
                        </v-row>

                        <v-row justify="center">
                          <v-btn
                            color="secondary"
                            type="submit"
                            :loading="loading"
                            :disabled="invalid"
                            :elevation="0"
                            >Restablecer</v-btn
                          >
                        </v-row>
                      </form>
                    </ValidationObserver>
                  </v-card-text>
                </v-card>
                <v-card rounded elevation="0" class="px-6" v-else>
                  <v-card-text>
                    <v-row justify="center">
                      <span class="logo-container__text">
                        {{ message }}
                      </span>

                      <span class="logo-container__text_two">
                        En caso de no haberlo recibido.
                        <a v-on:click="handleSubmit()" class="mx-1"
                          >Haga click aquí
                        </a>
                        para enviarlo nuevamente
                      </span>
                    </v-row>
                    <v-row justify="center" class="mt-8">
                      <RouterLink :to="{ name: 'Login' }" class="btn-default">
                        <span justify="center" class="logo-container__text primary--text">
                          Iniciar Sesión
                        </span>
                      </RouterLink>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import UserService from '@/services/user'
export default {
  data() {
    return {
      disabled: 0,
      loading: false,
      correoSend: false,
      message: null,
      user: {
        email: ''
      }
    }
  },
  computed: {
    imgCard() {
      // return require('@/assets/logo-safe.png')
      return ''
    }
  },
  methods: {
    async handleSubmit() {
      this.loading = true
      this.correoSend = false
      this.disabled = 1
      try {
        let lang = navigator.language.substr(0, 2)
        var data = await UserService.sendEmailConfirmation(
          this.user.email,
          lang
        )
        this.correoSend = true
        this.message = data.message
      } catch (e) {
        this.$dialog.notify.error(e.message)
        this.user.email = ''
        this.correoSend = false
      } finally {
        this.loading = false
        this.disabled = 0
      }
    }
  }
}
</script>

<style>
#auth label.v-label {
  transform: translateY(-18px) scale(.75);
}
</style>
<style scoped>
.logo {
  max-width: 350px;
}

.theme--light.v-application.bg-login {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: '';
  z-index: 0;
  background: #ffffff;
}

.left__text {
  position: absolute;
  left: 20px;
  bottom: 20px;
}

.links a {
  font: normal normal normal 16px/27px 'Libre Franklin';
  letter-spacing: 0px;
  color: #00559e;
  opacity: 1;
  text-decoration: none;
}

.logo-container__text {
  text-align: center;
  font: normal normal normal 16px/12px 'Libre Franklin';
  letter-spacing: 0;
  line-height: 1.5;
  color: #8990ad;
  opacity: 1;
}

.logo-container__text_two {
  margin-top: 20px;
  text-align: center;
  font: normal normal normal 16px/12px 'Libre Franklin';
  letter-spacing: 0;
  line-height: 1.5;
  color: #8990ad;
  opacity: 1;
}

.form label {
  font: normal normal normal 12px/15px 'Libre Franklin';
  letter-spacing: 0px;
}

@media (max-width: 979px) {
  .logo-container__text {
    font: normal normal normal 16px/18px 'Libre Franklin';
  }
  .logo-container__text_two {
    font: normal normal normal 16px/18px 'Libre Franklin';
  }
}
</style>
